import React from "react"
import PropTypes from "prop-types"
import VisuallyHidden from "../visually-hidden"
import Button from "."
import cx from "classnames"

const SIZES = {
  sm: "w-8",
  md: "w-10",
  lg: "w-12"
}

/**
 * @param {Object} props
 * @param {"primary"|"secondary"|"tertiary"|"plain"} props.is
 * @param {"sm"|"md"|"lg"} props.size
 * @param props.label A11y label
 * @param props.children The icon element to render
 * @param className any custom classes to be applied to button
 */
const IconButtonBase = React.forwardRef(
  ({ label, size = "md", children, className, ...props }, ref) => {
    return (
      <Button
        {...props}
        size={size}
        className={cx(SIZES[size], className)}
        ref={ref}
      >
        <VisuallyHidden>{label}</VisuallyHidden>
        {children}
      </Button>
    )
  }
)

IconButtonBase.propTypes = {
  label: PropTypes.string.isRequired,
  size: PropTypes.oneOf(Object.keys(SIZES)),
  className: PropTypes.string,
  children: PropTypes.node.isRequired
}

export default IconButtonBase
